import Loader from 'react-js-loader';

export const UploadLoader = () => {
  return (
    <div className="bubble-loader">
      <Loader type="bubble-ping" bgColor={'#1C8CA6CC'} size={40} />
    </div>
  );
};
